import React from "react";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { COMPANY, SERVICES } from "../data/constants";
import BrandWordmark from "./BrandWordmark";

const scrollTo = (id) => (e) => {
  e.preventDefault();
  const el = document.getElementById(id);
  if (el) {
    const y = el.getBoundingClientRect().top + window.scrollY - 88;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0B0F19] border-t border-white/10"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 py-20 md:py-28">
        {/* Massive wordmark */}
        <div className="border-b border-white/10 pb-12 md:pb-16">
          <BrandWordmark size="xl" align="left" data-testid="footer-wordmark" />
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 pt-12 md:pt-16">
          {/* About */}
          <div className="md:col-span-5">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#F47B20] mb-4">
              About
            </p>
            <p className="text-white/70 text-base leading-relaxed max-w-md">
              {COMPANY.name} is a Pune-based digital transformation consultancy.
              Since {COMPANY.established} we have been helping businesses
              consult, automate and grow — across ERP, integrations, web and
              print.
            </p>
          </div>

          {/* Services */}
          <div className="md:col-span-3">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#F47B20] mb-4">
              Services
            </p>
            <ul className="space-y-3">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <a
                    href="#services"
                    onClick={scrollTo("services")}
                    data-testid={`footer-service-${s.id}`}
                    className="group inline-flex items-center gap-2 text-white/80 hover:text-[#F47B20] transition-colors"
                  >
                    {s.name}
                    <ArrowUpRight className="w-3.5 h-3.5 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#F47B20] mb-4">
              Contact
            </p>
            <ul className="space-y-4 text-white/80">
              <li>
                <a
                  href={`tel:${COMPANY.phone}`}
                  data-testid="footer-phone"
                  className="inline-flex items-start gap-3 hover:text-[#F47B20] transition-colors"
                >
                  <Phone className="w-4 h-4 mt-1 text-[#F47B20]" />
                  {COMPANY.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  data-testid="footer-email"
                  className="inline-flex items-start gap-3 hover:text-[#F47B20] transition-colors break-all"
                >
                  <Mail className="w-4 h-4 mt-1 text-[#F47B20]" />
                  {COMPANY.email}
                </a>
              </li>
              <li className="inline-flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 text-[#F47B20]" />
                <span>{COMPANY.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs uppercase tracking-[0.25em] text-white/50">
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <p className="text-xs uppercase tracking-[0.25em] text-white/50">
            Consult · Automate · Grow
          </p>
        </div>
      </div>
    </footer>
  );
}
